export const URLConfiguration = {
    paths: {
        catalogos: {
            getObtenerCatalogos     : 'miep/ux-ma-gestion-poliza/v1/catalogos/solicitud-endoso-rentas'
        },
        poliza: {
            validaEndosoPoliza      : 'miep/ux-ma-gestion-poliza/v1/poliza/{idPoliza}/producto/{idProducto}/solicitud-endoso/validar-endoso-poliza?tipoEndoso={tipoEndoso}',
            registrarEndosoPoliza   : 'miep/ux-ma-gestion-poliza/v1/poliza/{idPoliza}/producto/{idProducto}/solicitud-endoso'
        },
        otp: {
            enviarCorreo            : 'miep/ux-ma-gestion-poliza/v1/otp/enviar-correo',
            enviarSMS               : 'miep/ux-ma-gestion-poliza/v1/otp/enviar-sms',
            verificarCodigo         : 'miep/ux-ma-gestion-poliza/v1/otp/verificar'
        }
    }
}